// extracted by mini-css-extract-plugin
export default {"content-browser__content":"content-browser_content-browser__content__BavW7"};